<!-- @format -->

<template>
  <div class="tree">
    <div class="tree-level d-flex">
      <div class="tree-level-item" v-for="(item, index) in treeLevel" :key="index" :style="{ background: item.color }">
        {{ item.name }}
        <!--        输入会员id-->
      </div>

      <!--      <b-form-input v-model="member" class="d-inline-block mr-1" placeholder="Please enter member name" @input="changeSome" />-->
    </div>
    <b-button v-if="lock" @click="centerScale($refs.div1.$el)" style="z-index: 99; position: relative; margin: 10px">还原</b-button>
    <div class="tree-content" @mousedown.stop="move" ref="treeData">
      <tree-item :tree-data="treeData" :tree-level="treeLevel" :tree-first="true" ref="div1" />
    </div>
  </div>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt'
import axiosIns from '@/libs/axios'
import { BButton } from 'bootstrap-vue'
import { codeSearch } from './code'
import TreeItem from './TreeItem.vue'

export default {
  components: {
    TreeItem,
    BButton,
  },
  data() {
    return {
      member: '',
      treeData: [],
      codeSearch,
      searchword: '',
      tree: [],
      treeLevel: [],
      colorArray: ['#e6e2e3', '#f5eb56', '#b6cca5', '#86b6da', '#cb7a77', '#595c87', '#cd8d51', '#0f9289'],
      lock: false,
    }
  },
  created() {
    this.shuju()
  },
  mounted() {
    this.$nextTick(() => {
      const _this = this
      const oDiv = this.$refs.div1.$el
      const box = document.getElementsByClassName('tree-content')[0]
      // console.log(oDiv, box)
      let scal = 1

      function onMouseWheel(ev) {
        /* 当鼠标滚轮事件发生时，执行一些操作 */
        _this.lock = true
        var ev = ev || window.event
        let down = true // 定义一个标志，当滚轮向下滚时，执行一些操作
        down = ev.wheelDelta ? ev.wheelDelta < 0 : ev.detail > 0
        if (down) {
          // console.log('鼠标滚轮向下放大---------')
          scal = (parseFloat(scal) + 0.01).toFixed(2)
          // console.log(`放大系数: ${scal}`)
          oDiv.style.transform = `scale(${scal})` // scale()在这里要使用拼接的方式才能生效
          oDiv.style.transformOrigin = '0 0'
        } else {
          console.log('鼠标滚轮向上缩小++++++++++')
          if (scal == 0.01) {
            scal = 0.01
            return
          }
          scal = (parseFloat(scal) - 0.01).toFixed(2)

          console.log(`缩小系数: ${scal}`)
          oDiv.style.transform = `scale(${scal})` // scale()在这里要使用拼接的方式才能生效。
          oDiv.style.transformOrigin = '0 0'
        }
        if (ev.preventDefault) {
          /* FF 和 Chrome */
          ev.preventDefault() // 阻止默认事件
        }
        return false
      }

      function addEvent(obj, xEvent, fn) {
        if (obj.attachEvent) {
          obj.attachEvent(`on${xEvent}`, fn)
        } else {
          obj.addEventListener(xEvent, fn, false)
        }
      }
      addEvent(box, 'mousewheel', onMouseWheel)
      addEvent(box, 'DOMMouseScroll', onMouseWheel)
    })
  },
  methods: {
    changeSome(val) {
      this.shuju(val)
    },
    centerScale(oDiv) {
      oDiv.style.transform = `scale(${1})`
      oDiv.style.transformOrigin = '0 0'
      this.lock = false
      // $("#drag").css({"transform": "scale(" + scal + ")","transformOrigin": "0 0"});//jquery写法
    },
    async shuju(val = '') {
      const userInfo = await axiosIns.get('order/create-user')
      useJwt.offlineTree().then(response => {
        this.treeData = [
          {
            ...JSON.parse(localStorage.getItem('userData')),
            ...userInfo.data,
            child: [...response?.data?.list],
          },
        ]
      })
      axiosIns.get('/user/userLevelList').then(response => {
        this.treeLevel = response.data
        // 追加一个 16进制的颜色
        this.treeLevel.forEach((item, index) => {
          item.color = this.colorArray[index]
        })
      })
    },
    vip(e) {
      // console.log(e)
      useJwt.offlineTree({ user_id: e }).then(response => {
        // console.log(response)
        this.tree_two = response.data.notActive.list
      })
    },
    move(e) {
      const odiv = e.currentTarget // 获取元素
      // console.log(odiv);
      // 算出鼠标相对元素的位置
      const disX = e.clientX - odiv.offsetLeft
      const disY = e.clientY - odiv.offsetTop
      document.onmousemove = e => {
        // 鼠标按下并移动的事件
        // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
        const left = e.clientX - disX
        const top = e.clientY - disY

        // 绑定元素位置到positionX和positionY上面
        this.positionX = top
        this.positionY = left
        // 移动当前元素
        odiv.style.left = `${left}px`
        odiv.style.top = `${top}px`
      }
      document.onmouseup = () => {
        document.onmousemove = null
        document.onmouseup = null
      }
    },
  },
  beforeDestroy() {
    document.onmousemove = null
    document.onmouseup = null
    this.treeLevel = this.tree = []
  },
}
</script>
<style lang="scss" scoped>
.tree {
  background: rgb(105, 105, 105);
  overflow: hidden;
  min-height: calc(100vh - 110px);
  position: relative;

  .tree-content {
    position: absolute;
    top: 80px;
    left: 0;
    width: 100%;
    max-height: 80vh;
    height: 80vh;
  }
}
.tree-level {
  margin: 10px 10px;
  div.tree-level-item {
    width: 80px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    margin-right: 10px;
    color: #000;
    position: relative;
    border-radius: 10px;
    z-index: 99;
    div.pos {
      position: absolute;
      top: 0;
      right: 0;
      height: 10px;
      width: 20px;
    }
  }
}
</style>
